import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { get, isEmpty } from 'lodash'
import { formatDateFields } from '../../helpers'
import SearchBar from '../SearchBar'
import '../css/View.css'
import { getRedemptionGroups } from '../../api/redemptionCodesApi'
import ReportTypes from '../reports/reportTypes'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataTableBase from '../utils/DataTable';

const initialRedemptionCodes = {
    currentPage: 0,
    pageCount: 1,
    pageSize: 10,
    results: [],
    rowCount: 0,
    orderBy: 'createdDate',
    descending: true,
}

const RedemptionCodesView = () => {
    const history = useHistory()

    const [redemptionCodes, setRedemptionCodes] = useState(initialRedemptionCodes)
    const [isLoading, setIsLoading] = useState(true)

    const handlePageSizeChange = async pageSize => {
        setRedemptionCodes({ ...redemptionCodes, pageSize })
    }

    const handleRowClick = rowData => {
        history.push({
            pathname: `/secure/redemptionCodesEdit/${rowData.redemptionGroupId}`,
            state: {
                ...rowData,
            },
        })
    }

    const handleNewRedemptionCodeClick = () => {
        history.push({
            pathname: '/secure/redemptionCodesCreate',
        })
    }

    const handleRedemptionCodesChange = redemptionCodesData => {
        setRedemptionCodes({ ...redemptionCodes, ...redemptionCodesData })
    }

    const handleClickOnReport = () => {
        history.push({
            pathname: '/secure/redemptions/report',
            state: { report: ReportTypes.RedemptionCodeUsageReport }
        })
    }
    const handleSearchBarChange = async event => {
        const searchValue = get(event, 'target.value') || ''
        if (event.key === 'Enter' || !searchValue) {
            try {
                setIsLoading(true)
                await getRedemptionGroups({
                    callback: handleRedemptionCodesChange,
                    pageSize: get(redemptionCodes, 'pageSize') || 10,
                    ...(searchValue && { filter: searchValue }),
                    orderBy: get(redemptionCodes, 'orderBy'),
                    descending: get(redemptionCodes, 'descending'),
                })
                setIsLoading(false)
                return null
            } catch (error) {
                setIsLoading(false)
                setRedemptionCodes({ ...redemptionCodes, results: [] })
                return error
            }
        }

        return null
    }

    const handlePageChange = async currentPage => {
        try {
            setIsLoading(true)
            await getRedemptionGroups({
                callback: handleRedemptionCodesChange,
                pageSize: get(redemptionCodes, 'pageSize') || 10,
                currentPage,
                orderBy: get(redemptionCodes, 'orderBy'),
                descending: get(redemptionCodes, 'descending'),
            })
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }
    }

    const columns = [
        {
            name:
                <div
                    style={{
                        textIndent: 10,
                        textAlign: "left",
                        width: 170,
                    }}
                >
                    Name <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '210px',
            selector: row => row.redemptionName,
            sortable: true,
            sortField: 'redemptionName',
            cell: row => <div onClick={() => handleRowClick(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.redemptionName}</p></div>
        },
        {
            name:
                <div
                    style={{
                        textIndent: 10,
                        textAlign: "left",
                        width: 170,
                    }}
                >
                    Branch <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '230px',
            selector: row => row.branchName,
            sortable: true,
            sortField: 'branchName',
            cell: row => <div onClick={() => handleRowClick(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.branchName}</p></div>
        },
        {
            name:
                <div
                    style={{
                        textIndent: 10,
                        textAlign: "left",
                        width: 170,
                    }}
                >
                    Code <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '170px',
            selector: row => row.redemptionCode,
            sortable: true,
            sortField: 'redemptionCode',
            cell: row => <div onClick={() => handleRowClick(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.redemptionCode}</p></div>
        },
        {
            name:
                <div
                    style={{
                        textIndent: 10,
                        textAlign: "left",
                        width: 170,
                    }}
                >
                    Status <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '150px',
            selector: row => row.status,
            sortable: true,
            sortField: 'status',
            cell: row => <div onClick={() => handleRowClick(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.status}</p></div>
        },
        {
            name:
                <div
                    style={{
                        textIndent: 10,
                        textAlign: "left",
                        width: 170,
                    }}
                >
                    Start date <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '170px',
            selector: row => row.startDate,
            sortable: true,
            sortField: 'startDate',
            cell: row => <div onClick={() => handleRowClick(row)}><p style={{ marginLeft: "10px", }} className="cursor">{formatDateFields(row.startDate)}</p></div>
        },
        {
            name:
                <div
                    style={{
                        textIndent: 10,
                        textAlign: "left",
                        width: 170,
                    }}
                >
                    End date <FontAwesomeIcon icon="sort" size="sm" />
                </div>,
            width: '170px',
            selector: row => row.endDate,
            sortable: true,
            sortField: 'endDate',
            cell: row => <div onClick={() => handleRowClick(row)}><p style={{ marginLeft: "10px", }} className="cursor">{formatDateFields(row.endDate)}</p></div>
        }]

    useEffect(() => {
        const fetchRedemptionGroups = async () => {
            try {
                setIsLoading(true)
                await getRedemptionGroups({
                    callback: handleRedemptionCodesChange,
                    pageSize: get(redemptionCodes, 'pageSize'),
                    orderBy: get(redemptionCodes, 'orderBy'),
                    descending: get(redemptionCodes, 'descending'),
                })
                setIsLoading(false)
            } catch (error) {
                setIsLoading(false)
            }
        }

        fetchRedemptionGroups()
    }, [redemptionCodes.pageSize, redemptionCodes.orderBy, redemptionCodes.descending])

    const handleOrderData = event => {
        const orderByEvent = event.sortField
        const descEvent = get(redemptionCodes, 'descending')
        setRedemptionCodes({
            ...redemptionCodes,
            orderBy: orderByEvent,
            descending: !descEvent,
        })
    }


    return (
        <div>
            <div className="mb-3">
                <SearchBar
                    onKeyUp={handleSearchBarChange}
                    onClick={handleSearchBarChange}
                    onChange={handleSearchBarChange}
                />
                {!isEmpty(get(redemptionCodes, 'results') || []) && (


                    <DataTableBase
                        columns={columns}
                        isLoading={isLoading}
                        data={get(redemptionCodes, 'results') || []}
                        paginationTotalRows={get(redemptionCodes, 'rowCount')}
                        paginationPerPage={get(redemptionCodes, 'pageSize')}
                        paginationDefaultPage={1}
                        onChangeRowsPerPage={handlePageSizeChange}
                        onChangePage={handlePageChange}
                        onSort={handleOrderData}
                    />
                )}
                <button type="button" onClick={() => handleNewRedemptionCodeClick()} className="btn mt-4">
                    + REDEMPTION
                </button>
                <button type="button" className="btn mt-4 ml-4 mx-4" onClick={handleClickOnReport} className="btn mt-4 ml-2">
                    Reports
                </button>
            </div>
        </div>
    )
}

export default RedemptionCodesView
